var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h17.8v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M17.8 0h17.8v40H17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M35.6 0h17.7v40H35.6zm-8.9 15.3-1.5 4.5 2.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m26.7 15.3 1.4 4.5-2.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M31.2 18.5h-4.8V21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m31.2 18.5-3.8 2.8-1.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M29.5 23.8 28 19.3l-2.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m29.5 23.8-3.9-2.7 1.4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m23.9 23.8 3.8-2.7-1.3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m23.9 23.8 1.4-4.5 2.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m22.2 18.5 3.8 2.8 1.4-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M22.2 18.5h4.7V21z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCm);
export default __webpack_public_path__ + "static/media/cm.5cf0134c5f9f8db4710886010b25b147.svg";
export { ForwardRef as ReactComponent };